export default "__VITE_ASSET__AyCYpNN9__"